import { render, staticRenderFns } from "./sendMessageToCustomers.vue?vue&type=template&id=71b5c641"
import script from "./sendMessageToCustomers.vue?vue&type=script&lang=js"
export * from "./sendMessageToCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports